<template>
  <div class="block-component"
       :class="[
         `size-${size}`,
       ]"
  >
    <div class="block-header">
      <h2 class="block-title">
        <slot name="icon"></slot>
        <span class="text">{{ title }}</span>
      </h2>
      <slot name="headerRight">
        <div v-if="more"
             class="block-more"
             @click="handleClickMore"
        >
          {{ moreDesc }}
          <ym-icon class="icon"
                   name="right" />
        </div>
      </slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  import validator from '@/utils/validator';

  export default {
    name: 'Block',
    props: {
      title: {
        type: String,
      },
      more: {
        type: Boolean,
        default: false,
      },
      moreDesc: {
        type: String,
        default: '更多',
      },
      explore: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      size: {
        type: String,
        default: 'normal',
        validator(val) {
          return [
            'normal',
            'medium',
            'small',
          ].includes(val);
        },
      },
      isRecommend: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleClickMore() {
        this.$emit('click-more', this.explore);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @block_header_height: 100px;

  .block {
    &-component {
      background-color: @color-white;

      &.size-medium {
        .block-title {
          font-size: @font-size-medium;
        }
      }

      &.size-small {
        .block-title {
          font-size: @font-size-base;
        }
      }
    }

    &-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: @size-medium @size-base @size-extra-small @size-base;
      position: relative;
    }

    &-title {
      display: flex;
      align-items: center;
      margin: 0;
      font-size: @font-size-extra-large;
      color: @color-text-base;
      font-weight: @font-weight-bold;
      line-height: 1;
    }

    &-more {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: @font-size-base;
      line-height: 1;
      color: @color-text-lighter;
      padding: 0;
      .icon {
        font-size: @font-size-small;
      }
    }
  }
</style>
